import type { App } from 'vue';
import AdvisorButton from '@src/Advisor/Pages/AdvisorButton.vue';
import AdvisorDrawer from '@src/Advisor/Pages/AdvisorDrawer.vue';

/**
 * Modular setup — registers the layout-slot components the provider adds to
 * app('layout.components') ('header-actions' → AdvisorButton, 'drawer-right'
 * → AdvisorDrawer), and the live-demo embed components (islands are mounted
 * into server-rendered manual HTML by useManualEmbeds via its own registry).
 */
export function setup(app: App): void {
    app.component('AdvisorButton', AdvisorButton);
    app.component('AdvisorDrawer', AdvisorDrawer);
}
